import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "pageTitle": "Password Input Design Guidelines",
  "title": "Password Input",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <PageContent componentName="password_input" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Use the password input when you want to keep the user's password masked for
  security.
      </LeadParagraph>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "756px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "69.88416988416989%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAhUlEQVQoz9WSyw4CIRAE9/8/FIFhOMji9ACjHnysF0zMJhrrXumku5fLDpa98vmF7ybXWp1zROS9B/CZDCClxMw5ZxEBIBNU0RoAmNkmMzM9eBNVSjv4U1kbIHdZVYkohBBjTCm1Cb23YxHOtayiqlvbZvYsvM8ZY5iNMfptl+WnJ/lD+QriWT3LAAjQ8AAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/static/3ea4e7341c55c35caddc0981a3d5cb0b/8ae3e/password-input-example.png",
              "srcSet": ["/static/3ea4e7341c55c35caddc0981a3d5cb0b/a2ead/password-input-example.png 259w", "/static/3ea4e7341c55c35caddc0981a3d5cb0b/6b9fd/password-input-example.png 518w", "/static/3ea4e7341c55c35caddc0981a3d5cb0b/8ae3e/password-input-example.png 756w"],
              "sizes": "(max-width: 756px) 100vw, 756px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>
      </figure>
      <hr></hr>
      <h2>{`Anatomy`}</h2>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1004px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.42084942084942%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABPElEQVQoz5VSXUsDMRC8//8r9Bf4IOhDVfChoAWpglAEC7VU0N5HLsnu5ZKrO5KcpQdqrQ/DDsvu7G4mGTODLIE/Ali6njMnEO34PhCRfHHJyNokVl9Noc4micdcFPsHZCuckTbgzkNdP0BfTtEkwcM2G0BiD1krGaNDEzxW+Tvmr0u8LBbQWqfJMe6DtQZEFtZa4U2I10lWHY1g7p+htIYqSiilEmKD9x4hhG/wvo/GOhQFwTBLPbqDOr2RTJ1PYJ+WqGqFMs9RFiXKshdumgbOuR/Rti3qmrBea2hjRd/OoMePkkVnm84jz3O86QrrskCtVGr6ywxmgnP9G6aTNyG5LGSscOelOr4QM1skHvOpcA+iq1uXe1Oiy9tpoYU6GcPMV4nvtjjoD+7+4XAaYyPcOhkU/brZIGIo+Am9b/3B/wKtFwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "password input anatomy",
            "title": "password input anatomy",
            "src": "/static/459f5791ac04aabd4d56b800b01d3b92/73b94/password-input-anatomy.png",
            "srcSet": ["/static/459f5791ac04aabd4d56b800b01d3b92/a2ead/password-input-anatomy.png 259w", "/static/459f5791ac04aabd4d56b800b01d3b92/6b9fd/password-input-anatomy.png 518w", "/static/459f5791ac04aabd4d56b800b01d3b92/73b94/password-input-anatomy.png 1004w"],
            "sizes": "(max-width: 1004px) 100vw, 1004px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <ol>
        <li parentName="ol">{`Field label`}</li>
        <li parentName="ol">{`Masked password`}</li>
        <li parentName="ol">{`Reveal password`}</li>
        <li parentName="ol">{`Helper text`}</li>
      </ol>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      